
// ACADEMIC YEARS
export const GET_ACADEMIC_CYCLE_CONFIGS = "/academic-cycle-configs";
export const ADD_NEW_ACADEMIC_CYCLE_CONFIG = "/academic-cycle-configs";
export const UPDATE_ACADEMIC_CYCLE_CONFIG = "/academic-cycle-configs";
export const DELETE_ACADEMIC_CYCLE_CONFIG = "/academic-cycle-configss";


